import { queryOptions } from '@tanstack/react-query';
import {
  KnowledgeBasesService,
  type KnowledgeBaseWorkspacesDto,
  type UpdateKnowledgeBaseWorkspacesDto,
} from '@inference.engine/assets-api-client/web';

import { assetsHttp } from '@/lib/api/assets-client';
import { KNOWLEDGE_BASES_QUERY_KEYS } from '@/entities/knowledge-base';

/**
 * Which workspaces a knowledge base is shared with, as the caller is allowed to see them: it can
 * be shared more widely than this returns, with the rest reported only as a count.
 */
const getKnowledgeBaseWorkspaces = async (
  knowledgeBaseId: string,
): Promise<KnowledgeBaseWorkspacesDto> => {
  const response = await KnowledgeBasesService.getKnowledgeBaseWorkspaces({
    client: assetsHttp,
    throwOnError: true,
    path: { id: knowledgeBaseId },
  });

  return response.data;
};

export const knowledgeBaseWorkspacesQuery = (knowledgeBaseId: string | null | undefined) =>
  queryOptions({
    queryKey: KNOWLEDGE_BASES_QUERY_KEYS.workspaces(knowledgeBaseId!),
    queryFn: () => getKnowledgeBaseWorkspaces(knowledgeBaseId!),
    enabled: !!knowledgeBaseId,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

/** Applies a change of scope. The body is a delta, so a workspace the caller cannot see stays put. */
export const updateKnowledgeBaseWorkspaces = async (
  knowledgeBaseId: string,
  delta: UpdateKnowledgeBaseWorkspacesDto,
): Promise<KnowledgeBaseWorkspacesDto> => {
  const response = await KnowledgeBasesService.updateKnowledgeBaseWorkspaces({
    client: assetsHttp,
    throwOnError: true,
    path: { id: knowledgeBaseId },
    body: delta,
  });

  return response.data;
};
